import React, { useState } from "react";
import { Button, Modal, Offcanvas } from "react-bootstrap";
import "./Use_Current_Location.css";
import Your_Location_modal from "../Your_Location_modal/Your_Location_modal";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentLocation } from "../../../../features/location/locationSlice";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Use_Current_Location(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [locationText, setLocationText] = useState("Use Current Location");
  const [isLoading, setIsLoading] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false); // State for the "Type manually" modal



  const handleShowLocationModal = () => {
    setShowLocationModal(true); // Show the "Type manually" modal
    props.onHide();
  };

  const handleCloseLocationModal = () => {
    setShowLocationModal(false); // Close the "Type manually" modal
  };

  const handleOpenLocationModal = () => {
    setShowLocationModal(true); // Close the "Type manually" modal
  };


  const current_location = useSelector((state) => state.location.current_location);

  const dispatch = useDispatch();



  const handleUseCurrentLocation = async () => {
    setLocationText("Fetching your location...");
    setIsLoading(true);

    try {
      const res = await dispatch(getCurrentLocation());
      if (res.meta.requestStatus === "fulfilled") {
        setLocationText("Location fetched");
        setTimeout(() => { props.onHide(); setIsLoading(false); }, 2000);
      } else if (res.meta.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Failed to fetch location");
        setLocationText("Failed to get location");
      }
    } catch (error) {
      console.error("Error in location fetch:", error);
      setLocationText("An unexpected error occurred.");
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <>
      <section className="Use_Current_Location">
        {['end'].map((placement, idx) => (
          <Offcanvas
            show={show} onHide={handleClose} {...props} key={idx} placement={placement} name={placement}
            className="Use_Current_Location_offcanvas modal-holder"
          >
            <Offcanvas.Body>
              <div>
                <div className="logo_holder">
                  <img
                    src="/assets/images/header/header_logo2.png"
                    className="logo_img"
                  />
                </div>
                <div className="heading_holder">
                  <h3>Location</h3>
                </div>
                <div className="address-text-holder">
                  <div className="icon-holder">
                    <img
                      className="icon-img"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icons/green_location.png"
                      }
                      alt="Location Icon"
                    />
                  </div>
                  <div className="text-holder">
                    <p>
                      To get quick delivery, we would like to ensure your currect location
                    </p>
                  </div>
                </div>

                <div className="footer-btn-holder">
                  <div className="text-center btn_holder">
                    <Green_Btn btn_name="Type manually" onClick={handleShowLocationModal} />
                    {/* <Button
                  className="submit-btn "
                  type="button"
                  onClick={handleShowLocationModal} // Open the "Type manually" modal
                >
                  Type manually
                </Button> */}
                  </div>

                  <div className="close_div"
                    onClick={() => {
                      props?.onHide();
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} className="close_icon" />
                  </div>

                  <div className="text-center btn_holder">
                    <Button
                      className="use-btn "
                      type="button"
                      onClick={handleUseCurrentLocation}
                      disabled={isLoading} // Disable the button while loading
                    >
                      {locationText}
                    </Button>
                  </div>
                </div>
              </div>
            </Offcanvas.Body>
            <div className="overlay_holder"></div>
          </Offcanvas>
        ))}

        {/* Your Location Modal */}
        <Your_Location_modal
          show={showLocationModal}
          onHide={handleCloseLocationModal}
          onOpen={handleOpenLocationModal}
          onBackToChooseLocation={handleCloseLocationModal}
          onOpenYourLocation={handleCloseLocationModal}
          setShowConfimLocModal={props?.setShowConfimLocModal}
        />
      </section>
    </>
  );
}

export default Use_Current_Location;
